import {
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  TextField,
  Divider,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AppCommonPopup = ({
  open,
  onClose,
  onConfirm,
  message,
  confrimLabel = "Ok",
  textareaRef,
  isSendForApproval,
  handleSendComments,
  isRejected,
  title,
  isLoading = false,
  isDocumentProceed,
  isDeleteTemplate
}) => {
  if (!open) {
    return null;
  }
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      PaperProps={{
        sx: { p: 0, minHeight: "4rem" },
      }}
    >
      {(isRejected || isDocumentProceed || isDeleteTemplate) && (
        <>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            px={3}
            pt={3}
          >
            <Typography>{title}</Typography>
            <IconButton onClick={onClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider sx={{ my: 1 }} />
        </>
      )}
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions
        sx={
          isSendForApproval || isRejected
            ? {
                px: 3,
                pb: 3,
                pt: 0,
                gap: 2,
                flexDirection: "column",
                alignItems: "stretch",
              }
            : { px: 3, pb: 3, pt: 0, gap: 2 }
        }
      >
        {(isSendForApproval ||
          isRejected) && (
            <TextField
              id="outlined-multiline-flexible"
              multiline
              rows={5}
              fullWidth
              onChange={(e) => handleSendComments(e)}
              placeholder={
                isRejected ? "Type Remarks..." : "Enter your comment here.."
              }
              inputRef={textareaRef}
              sx={{ width: "400px" }}
            />
          )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2,
            justifyContent: "flex-end",
            mt: 2,
          }}
        >
          <Button
            onClick={onClose}
            variant="outlined"
            size="small"
            sx={{
              borderColor: "#BE8976",
              color: "#BE8976",
              borderRadius: 1,
              fontSize: 14,
              height: 36,
              minWidth: 100,
              px: 2,
              "&:hover": {
                color: "#BE8976",
                borderColor: "#BE8976",
                backgroundColor: "#be897640",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            size="small"
            disabled={isLoading}
            sx={{
              bgcolor: "#BE8976",
              color: "#fff",
              borderRadius: 1,
              fontSize: 14,
              height: 36,
              minWidth: 100,
              px: 2,
              "&:hover": { bgcolor: "#9d5339" },
              "&:disabled": { bgcolor: "#ccc" },
            }}
          >
          {confrimLabel}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default AppCommonPopup;
